import React from "react";
import { GlobalTableStyles } from './globalTableStyles'
import { ConfigProvider, Select } from "antd";
import { NoteTableHeaderList, QuestionDetails, RateClassChangeLog } from "../../../Models/applicationModels";
import { formatUTCDateTime } from "../../../utils/formatUTCDate";
import { capitalizeFirstLetter, generateHierarchicalIndex } from "../../../utils/stringUtils";
import { mapAnswersToOptions, processSelectOptions } from "../../../utils/answerUtils";
import { rateClassTableHeaderList } from "../../../constants/tableHeaderList";

interface IGlobalTableProps {
    tableData: RateClassChangeLog[]
}

const RateClassTable = (props: IGlobalTableProps) => {
    const { tableData } = props

    const {
        tableStyle,
        tableHeader,
        tableCell,
        answerListMenu
    } = GlobalTableStyles().classes


    interface IRecursiveRowProps {
        data: QuestionDetails[];
        parentIndex: string;
        tableRowValue: RateClassChangeLog;
    }

    const RecursiveRow = (props: IRecursiveRowProps) => {
        const { data, parentIndex, tableRowValue } = props
        return (
            <>
                {data?.map((childRowValue: QuestionDetails, index: number,) => {
                    const currentIndex = generateHierarchicalIndex(parentIndex, index + 1);
                    const mappedAnswer = mapAnswersToOptions(childRowValue);
                    return (
                        <>
                            <tr>
                                <td className={tableCell}>
                                    {currentIndex}
                                </td>
                                <td className={tableCell}>
                                    {childRowValue.questionTitle}
                                </td>
                                <td className={tableCell}>
                                    {childRowValue.questionOptions?.length > 0
                                        ?
                                        <ConfigProvider renderEmpty={() => "No Options"} >
                                            <Select
                                                {...(mappedAnswer.length > 1 && { mode: "tags" })}
                                                removeIcon={false}
                                                className={answerListMenu}
                                                value={mappedAnswer}
                                                options={processSelectOptions(childRowValue.questionOptions, capitalizeFirstLetter)}
                                            />
                                        </ConfigProvider>
                                        :
                                        childRowValue["answer"].toString()
                                    }
                                </td>
                                <td className={tableCell}>
                                    {formatUTCDateTime(tableRowValue.createdOn)}
                                </td>
                            </tr>
                            {<RecursiveRow data={childRowValue.childQuestions} parentIndex={currentIndex} tableRowValue={tableRowValue} />}
                        </>
                    )
                })}
            </>
        )
    }

    const GetRowSpanValue = (rowValue: QuestionDetails[], finalValue: number) => {
        rowValue.map((question: QuestionDetails) => {
            finalValue = finalValue + 1
            if (question.childQuestions?.length > 0) {
                finalValue = GetRowSpanValue(question.childQuestions, finalValue)
            }
        })
        return finalValue
    }

    return (
        <>
            <table className={tableStyle}>
                <tr>
                    {rateClassTableHeaderList?.map((header: NoteTableHeaderList) => {
                        return (
                            <th
                                className={tableHeader}
                                style={{ width: header.width }}
                            >
                                {header.headerName}
                            </th>
                        )
                    })}
                </tr>

                {tableData?.map((tableRowValue: RateClassChangeLog) => {
                    const rowSpan = tableRowValue.questionDetails ? GetRowSpanValue(tableRowValue.questionDetails, 0) : 0
                    return (
                        tableRowValue.questionDetails !== null &&
                        tableRowValue.questionDetails?.map((rowValue: QuestionDetails, index: number) => {
                            const mappedTableRowValueAnswers = mapAnswersToOptions(rowValue)
                            return (
                                <>
                                    <tr>
                                        {index == 0 &&
                                            <td className={tableCell} rowSpan={rowSpan}>
                                                {tableRowValue.rateClass}
                                            </td>
                                        }

                                        <td className={tableCell}>
                                            {index + 1}
                                        </td>
                                        <td className={tableCell}>
                                            {rowValue.questionTitle}
                                        </td>
                                        <td className={tableCell}>
                                            {rowValue.questionOptions?.length > 0
                                                ?
                                                <ConfigProvider renderEmpty={() => "No Options"} >
                                                    <Select
                                                        {...(mappedTableRowValueAnswers.length > 1 && { mode: "tags" })}
                                                        removeIcon={false}
                                                        className={answerListMenu}
                                                        value={mappedTableRowValueAnswers}
                                                        options={processSelectOptions(rowValue.questionOptions, capitalizeFirstLetter)}
                                                    />
                                                </ConfigProvider>
                                                :
                                                rowValue["answer"].toString()
                                            }
                                        </td>
                                        <td className={tableCell}>
                                            {formatUTCDateTime(tableRowValue.createdOn)}
                                        </td>
                                    </tr>
                                    {rowValue?.childQuestions?.length > 0 &&
                                        <RecursiveRow data={rowValue.childQuestions} tableRowValue={tableRowValue} parentIndex={(index + 1).toString()} />
                                    }
                                </>
                            )
                        })
                    )
                })
                }
            </table>
        </>
    )
}

export default RateClassTable